// extracted by mini-css-extract-plugin
export default {"root":"grid_root__K+p0R","spanRow":"grid_spanRow__wsqCP"};